import { mount } from '../dom-lifecycle';

const messages = {
	size: (rules) => `Maksymalny rozmiar pliku to ${rules.size} MB`,
	type: (rules) => `Niepoprawny typ pliku, załącz plik typu: ${rules.type}`,
};

const validate = (file, rules) => {
	const errors = [];
	if (file.size > rules.size * 1024 * 1024) {
		errors.push("size");
	}
	// Porównujemy z listą rozszerzeń sprowadzoną do małych liter - lista pokazywana userowi
	// bywa etykietą ("JPG, PNG"), a wtedy includes() na surowej wartości odrzucałby poprawne
	// pliki .jpg. Patrz data-file-extensions w App\Form\Type\ReceiptFileUploadType.
	if (rules.extensions && !rules.extensions.includes(file.name.split('.').pop().toLowerCase())) {
		errors.push("type");
	}
	return errors;
};

mount(".form-file", root => {
	const input = root.querySelector("input[type=file]");
	const box = root.querySelector(".form-file-box");
	const badge = root.querySelector(".form-file-badge");
	// `accept` może być listą typów MIME (tak jest przy zdjęciu paragonu, żeby iOS transkodował
	// HEIC do JPEG) - takiej listy ani nie pokazuje się userowi, ani nie da się jej porównać
	// z rozszerzeniem pliku. Pola, które tego potrzebują, podają osobne data-* i wtedy one
	// wygrywają; bez nich zostaje stare zachowanie oparte o `accept`.
	const accept = $(input).attr("accept");
	const rules = {
		size: $(input).data("max-size"),
		type: $(input).data("file-types") || accept,
		extensions: String($(input).data("file-extensions") || accept || "").toLowerCase(),
	};

	if (rules.type) {
		root.querySelector(".file-type").textContent = String(rules.type)
			.split(",")
			.map(type => type.trim().replace(".", ""))
			.join(", ");
	}
	if (rules.size) {
		root.querySelector(".file-size").textContent = `${rules.size} MB`;
	}

	const reset = () => {
		root.classList.remove("has-file", "has-error");
		root.querySelector(".file-name").textContent = "";
	};

	input.addEventListener("change", () => {
		reset();
		const file = input.files[0];
		if (!file) {
			return;
		}
		const errors = validate(file, rules);
		if (errors.length) {
			input.value = "";
			badge.textContent = errors.map(error => messages[error](rules)).join(" ");
			root.classList.add("has-error");
			return;
		}
		root.querySelector(".file-name").textContent = file.name;
		root.classList.add("has-file");
	});

	["dragenter", "dragover"].forEach(type => box.addEventListener(type, event => {
		event.preventDefault();
		root.classList.add("is-dragover");
	}));
	["dragleave", "drop"].forEach(type => box.addEventListener(type, event => {
		event.preventDefault();
		root.classList.remove("is-dragover");
	}));
	box.addEventListener("drop", event => {
		if (event.dataTransfer.files.length) {
			input.files = event.dataTransfer.files;
			input.dispatchEvent(new Event("change"));
		}
	});

	input.form.addEventListener("reset", reset);
});
